export const btnHoverStyle = {
  cursor: "pointer",
  "&:hover": { color: "red" },
};

export const editHoverStyle = {
  cursor: "pointer",
  "&:hover": { color: "#1536db" },
};

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
export const flexCenter = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "center",
  alignItems: "center",
  gap: 2,
};

export const flex = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
};

export const flexColumn = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const arrowStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": { color: "red" },
};
